import { flatten } from 'lodash';

import { IMultiSelectDropDownOption } from '../../../components/___design/MultiSelectDropDownInput/MultiSelectDropDownInput.types';
import { EXPENSES } from '../../../shared/constants';

export const mapExpenseValueFromApi = (
  value: string[],
): IMultiSelectDropDownOption[] => {
  return flatten(
    value.map(item =>
      Object.values(EXPENSES).filter(expense => expense.value === item),
    ),
  );
};
